import React, { useContext, useState } from 'react';
import {
  alpha,
  IconButton,
  Tooltip,
  Popover,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme
} from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'src/theme/ThemeProvider';

const OPTIONS = [
  { value: 'light', Icon: LightModeOutlinedIcon },
  { value: 'dark', Icon: DarkModeOutlinedIcon },
  { value: 'system', Icon: SettingsBrightnessOutlinedIcon }
];

// Choix du thème dans l'en-tête : Clair, Sombre ou Système.
function HeaderTheme() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { preference, setPreference } = useContext(ThemeContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const current = OPTIONS.find((o) => o.value === preference) ?? OPTIONS[2];
  const brand = theme.colors.primary.main;

  const choose = (value) => {
    setPreference(value);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip
        title={`${t('theme_mode.title')} : ${t(`theme_mode.${current.value}`)}`}
        arrow
      >
        <IconButton
          onClick={(event) => setAnchorEl(event.currentTarget)}
          aria-label={t('theme_mode.title')}
          aria-haspopup="true"
          sx={{
            p: 0,
            width: 40,
            height: 40,
            borderRadius: '10px',
            transition: 'all 0.25s ease',
            '&:hover': {
              backgroundColor: alpha(brand, 0.1),
              transform: 'scale(1.05)'
            },
            '& svg': { fontSize: 24, color: brand }
          }}
        >
          <current.Icon />
        </IconButton>
      </Tooltip>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{ sx: { p: 1, borderRadius: 2, minWidth: 170 } }}
      >
        <List dense aria-label={t('theme_mode.title')}>
          {OPTIONS.map(({ value, Icon }) => {
            const selected = preference === value;
            return (
              <ListItemButton
                key={value}
                selected={selected}
                onClick={() => choose(value)}
                sx={{
                  borderRadius: 1,
                  '&.Mui-selected': {
                    backgroundColor: alpha(brand, 0.15),
                    '&:hover': { backgroundColor: alpha(brand, 0.25) }
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: 34, color: brand }}>
                  <Icon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={t(`theme_mode.${value}`)}
                  primaryTypographyProps={{ variant: 'body2' }}
                />
                {selected && (
                  <CheckRoundedIcon fontSize="small" sx={{ color: brand }} />
                )}
              </ListItemButton>
            );
          })}
        </List>
      </Popover>
    </>
  );
}

export default HeaderTheme;
